import { AlertTriangle, Inbox } from 'lucide-react';
import EmptyState from '../../components/EmptyState';
import Button from '../../components/Button';
import styles from './Analytics.module.css';

export default function WidgetShell({
  title,
  actions,
  loading,
  error,
  empty,
  emptyTitle = 'No sales in this range',
  onRetry,
  children,
  className = '',
}) {
  return (
    <section className={`${styles.widget} ${className}`}>
      <div className={styles.widgetHead}>
        <h2 className={styles.widgetTitle}>{title}</h2>
        {actions && <div className={styles.widgetActions}>{actions}</div>}
      </div>
      {loading && (
        <div className={styles.skeletonStack} aria-busy="true">
          <div className={styles.skeleton} />
          <div className={`${styles.skeleton} ${styles.skeletonShort}`} />
          <div className={styles.skeleton} />
        </div>
      )}
      {!loading && error && (
        <EmptyState
          icon={AlertTriangle}
          title="Could not load"
          description={error}
          action={onRetry ? <Button variant="outline" size="sm" onClick={onRetry}>Retry</Button> : null}
        />
      )}
      {!loading && !error && empty && (
        <EmptyState icon={Inbox} title={emptyTitle} description="Try a different range or channel." />
      )}
      {!loading && !error && !empty && children}
    </section>
  );
}
